module.exports = __webpack_public_path__ + "img/no-files-dark.a3f85efd.svg";